import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PARAM_PATHS } from '../navigation/paths.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// The page of any club, for anyone with a session: what it shows follows the reader's bond
// with that club, not the route. Why no role: apps/frontend/docs/la-societa.md.
export const clubRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PARAM_PATHS.club,
  params: numericIdParam('clubId'),
  beforeLoad: ({ context, location }) =>
    guardRoute({ queryClient: context.queryClient, currentPath: location.href }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/club.tsx')),
})

/** One club's page as a link target: `params` typed, so no page respells the path. */
export function clubPageLink(clubId: number) {
  return { to: NAV_PARAM_PATHS.club, params: { clubId } } as const
}
